import React from "react";
import { Reorder } from 'framer-motion';

import { matchPhrases } from "../../../utils/utilities";
import InfraredResultForm, { InfraredResult } from "../../forms/custom-infrared/infraredResultForm";

import AccordionItem from "../custom-visual-inspection/accordion-item";
import CustomNewItem from '../custom-general/custom-new-item';
import ReorderItem from '../../common/reorderItem';
import ItemCount from '../../blocks/item-count';

import toastService from "../../../services/toastService";

interface Props {
    infraredResultItems: InfraredResult[];
    onChangeInfraredResultItems: (items: InfraredResult[]) => void;
}

const InfraredResultItems: React.FC<Props> = ({ infraredResultItems, onChangeInfraredResultItems }) => {
    const handleAddItem = (item: InfraredResult) => {
        const itemMatch = infraredResultItems.find((analysisItem) => matchPhrases(analysisItem.imagingLocation, item.imagingLocation));
        if (itemMatch) return toastService.error(`Result ${item.imagingLocation} already exists!`);

        const newAnalysisItems = [...infraredResultItems, item];
        onChangeInfraredResultItems(newAnalysisItems);
    };

    const handleDeleteItem = (item: InfraredResult) => {
        const newAnalysisItems = infraredResultItems.filter((analysis) => analysis.imagingLocation !== item.imagingLocation);
        onChangeInfraredResultItems(newAnalysisItems);
    };
   
    const handleEditItem = (baseItem: InfraredResult, updatedItem: InfraredResult) => {
        const newAnalysisItems = infraredResultItems.map((analysis) => analysis.imagingLocation === baseItem.imagingLocation ? updatedItem : analysis);
        onChangeInfraredResultItems(newAnalysisItems);
    };

    return ( 
        <>
            <ItemCount count={infraredResultItems.length} label='Infrared Result' />
                            
            <CustomNewItem label='Add New Infrared Result'>
                <InfraredResultForm onSave={handleAddItem} />
            </CustomNewItem>
            
            <Reorder.Group className="list-unstyled" values={infraredResultItems} onReorder={onChangeInfraredResultItems}>
                {infraredResultItems.map((item) => (
                    <ReorderItem key={item.imagingLocation} value={item}>
                        <AccordionItem title={item.imagingLocation} isActive>
                            <InfraredResultForm
                                initialResultData={item}
                                onSave={(updated: InfraredResult) => handleEditItem(item, updated)}
                                onDeleteItem={() => handleDeleteItem(item)}
                            />
                        </AccordionItem>
                    </ReorderItem>
                ))}
            </Reorder.Group>
        </>
     );
};
 
export default InfraredResultItems;